import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

// @mui components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSnackbar from "components/SoftSnackbar";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Custom component
import AutomationProForm from "./components/AutomationProForm";

// API service
import autoLicenseService from "services/autoLicenseService";

function EditAutoLicense() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [license, setLicense] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    color: "info",
  });

  useEffect(() => {
    const fetchLicense = async () => {
      try {
        const data = await autoLicenseService.getLicenseById(id);
        setLicense(data);
        setIsLoading(false);
      } catch (err) {
        console.error("Failed to fetch license:", err);
        setError("Failed to load license data. Please try again.");
        setIsLoading(false);
        
        setNotification({
          open: true,
          message: "License not found or could not be loaded",
          color: "error",
        });
        
        // Redirect back to list after showing the error
        setTimeout(() => {
          navigate("/services/auto");
        }, 3000);
      }
    };
    
    fetchLicense();
  }, [id, navigate]);

  const handleCloseNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        {isLoading ? (
          <SoftBox display="flex" justifyContent="center">
            <SoftTypography variant="h6">Loading license data...</SoftTypography>
          </SoftBox>
        ) : error ? (
          <SoftBox display="flex" justifyContent="center">
            <SoftTypography variant="h6" color="error">
              {error}
            </SoftTypography>
          </SoftBox>
        ) : (
          <AutomationProForm license={license} isEdit={true} />
        )}
      </SoftBox>
      
      {/* Notification */}
      <SoftSnackbar
        color={notification.color}
        icon="notifications"
        title="Notification"
        content={notification.message}
        open={notification.open}
        onClose={handleCloseNotification}
        close={handleCloseNotification}
      />
      
      <Footer />
    </DashboardLayout>
  );
}

export default EditAutoLicense;